/**
 * @generated SignedSource<<804d12f011be0f7c6ff028a8c7235437>>
 * @relayHash 913e1883fcf11c39f3cc4f60e9910f01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 00e10794ef8151b82252d649e70988f4bcf85a5c86c38729c9f92a50448298ef

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery$variables = {
  isDevopsFeatureDisabledInFedRamp: boolean;
  versionAri: string;
};
export type ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery$data = {
  readonly jira: {
    readonly version: {
      readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionRelatedWork_RelatedWork">;
    };
  };
};
export type ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery = {
  response: ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery$data;
  variables: ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDevopsFeatureDisabledInFedRamp"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "versionAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "url"
},
v7 = {
  "kind": "ScalarField",
  "name": "relatedWorkId"
},
v8 = {
  "kind": "ScalarField",
  "name": "title"
},
v9 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v10 = {
  "kind": "ScalarField",
  "name": "name"
},
v11 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "ids",
          "value": [
            "assignee",
            "status"
          ]
        }
      ],
      "concreteType": "JiraIssueFieldConnection",
      "kind": "LinkedField",
      "name": "fieldsById",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueFieldEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v9/*: any*/),
                    {
                      "concreteType": "JiraStatus",
                      "kind": "LinkedField",
                      "name": "status",
                      "plural": false,
                      "selections": [
                        (v10/*: any*/),
                        {
                          "concreteType": "JiraStatusCategory",
                          "kind": "LinkedField",
                          "name": "statusCategory",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "statusCategoryId"
                            },
                            (v5/*: any*/)
                          ]
                        },
                        (v5/*: any*/)
                      ]
                    }
                  ],
                  "type": "JiraStatusField"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v9/*: any*/),
                    {
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        (v3/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "picture"
                        },
                        (v10/*: any*/),
                        (v5/*: any*/)
                      ]
                    }
                  ],
                  "type": "JiraSingleSelectUserPickerField"
                },
                (v5/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "fieldsById(ids:[\"assignee\",\"status\"])"
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "name": "__id"
},
v13 = {
  "kind": "ClientExtension",
  "selections": [
    (v12/*: any*/),
    {
      "kind": "ScalarField",
      "name": "isSaving"
    }
  ]
},
v14 = {
  "kind": "ClientExtension",
  "selections": [
    (v12/*: any*/)
  ]
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/)
  ],
  "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/),
    (v15/*: any*/),
    (v13/*: any*/)
  ],
  "type": "JiraVersionRelatedWorkV2",
  "abstractKey": "__isJiraVersionRelatedWorkV2"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "condition": "isDevopsFeatureDisabledInFedRamp",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "ui_softwareReleasesVersionRelatedWork_RelatedWork"
                      }
                    ]
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.version"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v4/*: any*/),
                        "concreteType": "JiraVersionRelatedWorkV2Connection",
                        "kind": "LinkedField",
                        "name": "relatedWorkV2",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraVersionRelatedWorkV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraVersionRelatedWorkV2"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "category"
                                  },
                                  {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v5/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v6/*: any*/),
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v11/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v13/*: any*/)
                                                ],
                                                "type": "JiraVersionRelatedWorkV2",
                                                "abstractKey": "__isJiraVersionRelatedWorkV2"
                                              },
                                              (v14/*: any*/)
                                            ],
                                            "type": "JiraVersionRelatedWorkGenericLink"
                                          },
                                          (v15/*: any*/),
                                          (v13/*: any*/)
                                        ],
                                        "type": "JiraVersionRelatedWorkV2",
                                        "abstractKey": "__isJiraVersionRelatedWorkV2"
                                      },
                                      (v14/*: any*/)
                                    ],
                                    "type": "JiraVersionRelatedWorkGenericLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v7/*: any*/),
                                      (v6/*: any*/),
                                      (v8/*: any*/),
                                      (v16/*: any*/)
                                    ],
                                    "type": "JiraVersionRelatedWorkConfluenceReleaseNotes"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v8/*: any*/),
                                      (v16/*: any*/)
                                    ],
                                    "type": "JiraVersionRelatedWorkNativeReleaseNotes"
                                  },
                                  (v14/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "cursor"
                              }
                            ]
                          },
                          {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "endCursor"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                              }
                            ]
                          }
                        ],
                        "storageKey": "relatedWorkV2(first:100)"
                      },
                      {
                        "args": (v4/*: any*/),
                        "handle": "connection",
                        "key": "version_relatedWorkV2",
                        "kind": "LinkedHandle",
                        "name": "relatedWorkV2"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "status"
                      },
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "canEditRelatedWork"
                      },
                      {
                        "alias": "allIssues",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": "ALL"
                          }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "totalCount"
                          }
                        ],
                        "storageKey": "issues(filter:\"ALL\")"
                      },
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "projectId"
                          },
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "versionId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "collapsedUis"
                      },
                      (v14/*: any*/)
                    ],
                    "type": "JiraVersion"
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "00e10794ef8151b82252d649e70988f4bcf85a5c86c38729c9f92a50448298ef",
    "metadata": {},
    "name": "ui_softwareReleasesVersionRelatedWork_RelatedWorkQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d8d66158505126260b0811b2a2af5336";

export default node;
